"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ApiManagerAdmin_1 = require("../../ApiManagerAdmin");
var ApiConfig_1 = require("../../config/ApiConfig");
var ApiGift = /** @class */ (function (_super) {
    __extends(ApiGift, _super);
    function ApiGift() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.GET_GOODS_BY_DATE = "/api/statistics/goodsByDate";
        _this.GET_GOODS_BY_ID = "/api/statistics/goodsByGoodsId";
        /**
         * 일자별 선물함 통계
         * @param accesstoken
         * @param request
         * @returns
         */
        _this.getGoodsByDate = function (accesstoken, request) {
            return ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.GET_GOODS_BY_DATE,
                data: request,
            });
        };
        /**
         * 선물함 이용권별 통계
         * @param accesstoken
         * @param request
         * @returns
         */
        _this.getGoodsById = function (accesstoken, request) {
            return ApiConfig_1.Axios.Manager({
                header: { accesstoken: accesstoken },
                method: "post",
                url: _this.GET_GOODS_BY_ID,
                data: request,
            });
        };
        return _this;
    }
    ApiGift.getInstance = function (initValue) {
        if (!ApiGift.classInstance) {
            this.classInstance = new ApiGift(initValue);
        }
        return this.classInstance;
    };
    return ApiGift;
}(ApiManagerAdmin_1.ApiManager));
exports.default = ApiGift;
